import React from "react";

import Button from "../atoms/Button";
import Container from "../atoms/Container";
import OperationsStack from "./OperationsStack";

export default function Hero() {
  return (
    <section className="relative overflow-hidden pb-4 pt-16 md:pb-6 md:pt-20">
      <Container>
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-3 inline-block rounded-full bg-blue-100 px-3 py-1 text-xs font-medium uppercase tracking-wide text-blue-800 dark:bg-slate-700 dark:text-blue-300">
            Built for operations teams
          </p>
          <h1 className="mb-5 text-4xl font-medium leading-tight tracking-tight text-gray-900 dark:text-gray-100 sm:text-5xl">
            Run your business, not your tools.
          </h1>
          <p className="mb-8 text-lg leading-relaxed text-gray-600 dark:text-gray-300">
            Digar brings orders, customers, products, sales reps, carriers, and
            customer communication into one place — so your team can focus on
            the work, not the workflow.
          </p>
          <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button href="/database/signup.php">Get started</Button>
            <Button href="/database/index.php" variant="secondary">
              Sign in
            </Button>
          </div>
        </div>

        <div
          aria-hidden="true"
          className="relative mx-auto mt-10 h-[360px] w-full max-w-3xl md:mt-12 md:h-[400px]"
        >
          <OperationsStack />
        </div>
      </Container>
    </section>
  );
}
